import styled from 'styled-components';
import media from '../../../constants/media';
import theme from '../../../constants/theme';
import { A } from '../../base/typography';

export const HeaderMain = styled.div`
	margin-bottom: 3rem;
`;

export const HeaderSub = styled.div`
	margin-top: 6rem;
	margin-bottom: 3rem;
	h5 {
		margin-top: 1rem;
		color: ${({ theme }) => theme.colors.gray};
	}
`;

export const LoaderWrapper = styled.div`
	display: flex;
`;

export const Card = styled.div`
	display: flex;
	flex-flow: column;
	box-shadow: 0px 11px 24px #ececec;
	height: 100%;
	border: 1px solid #f1f1f1;

	div:last-child {
		border-right: 0;
	}
`;

export const CardIcon = styled.div`
	width: 10rem;
	margin-left: -2rem;
	svg {
		width: 100%;
		height: 100%;
		max-height: 5rem;
	}
`;

export const CardLink = styled(A)`
	height: 100%;
	display: flex;
	justify-content: space-between;
	padding: 2.5rem 3rem 2rem 3rem;
	h6 {
		margin-bottom: 0.6rem;
	}
	span {
		color: ${({ theme }) => theme.colors.gray};
		font-size: 1.6rem;
		font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	}
	div + div {
		flex: 1;
	}
	div + svg {
		align-self: flex-end;
		height: 16px;
		width: 30px;
		margin-right: -1rem;
	}
`;

export const LinkWrapper = styled(A)`
	color: ${({ theme }) => theme.colors.gray};
`;

export const CardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-grow: 1;
	padding: 2rem 3rem;
	span {
		font-size: 1.6rem;
		flex: 1;
	}
	a {
		color: #8e979e;
		display: flex;
	}
	p {
		margin: 0 0 0.5rem 0;
	}
`;

export const CardFooter = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: #f9f9f9;
	padding: 1rem 2rem;
	div {
		display: flex;
		align-items: center;
		a {
			color: #8e979e;
			display: inline-flex;
		}
	}
	span {
		color: ${({ theme }) => theme.colors.secondary};
	}
	div > a:last-child {
		margin-left: 1rem;
	}
`;

export const CardFooterActions = styled.div`
	display: flex;
	align-items: center;
	a {
		color: #8e979e;
		display: inline-flex;
	}
	a:last-child {
		margin-left: 1rem;
	}

	svg {
		height: 2.5rem;
	}
`;

export const CardFooterRadio = styled.div`
	svg {
		color: #8e979e;
		height: 2.5rem;
		width: 2.5rem;
		margin-right: 1rem;
		margin-left: -1rem;
	}

	a {
		display: flex;
		font-size: 1.4rem;
	}

	${({ selected, theme }) =>
		selected &&
		`
		svg {
			fill: ${theme.colors.secondary};
		}
	`};
`;

export const IconHeader = styled.div`
	display: flex;
	align-items: center;

	svg {
		margin-right: 1rem;
		height: 3rem;
	}
`;

export const UserInfo = styled.div`
	display: flex;
	align-items: stretch;
	border-top: 1px solid #f1f1f1;

	${media.mobileOnly`
		display: block;
		border: 0;
	`}
`;

export const UserInfoItem = styled.div`
	position: relative;
	border-right: 1px solid #f1f1f1;
	padding: 1.4rem 6rem 1.4rem 3rem;
	svg {
		position: absolute;
		top: 2rem;
		right: 1.4rem;
		height: 1.6rem;
	}
	&:last-child {
		flex: 1;
	}
	p {
		margin: 0 0 0.5rem 0;
	}
	${media.mobileOnly`
		border-top: 1px solid #f1f1f1;
	`}
`;

export const UserInfoItemDouble = styled(UserInfoItem)`
	border-right: 1px solid #f1f1f1;
	> div {
		&:first-child {
			padding-right: 4rem;
			${media.mobileOnly`
				padding-bottom: 2rem;
			`}
		}
	}
	p {
		margin: 0 0 0.5rem 0;
	}
	${media.desktopSmall`
		display: flex;
	`}
`;

export const Email = styled.span`
	color: ${({ theme }) => theme.colors.primary};
`;

export const PaymentMethodInfo = styled.div`
	display: flex;
	svg {
		margin-right: 3rem;
		height: 5rem;
	}
`;

export const PaymentMethodStatus = styled.div`
	color: ${({ expired, theme }) => (expired ? theme.colors.primary : theme.colors.secondary)};
	align-self: flex-start;
`;

export const LinkGroup = styled.div`
	display: flex;
	align-items: center;
	a {
		color: ${theme.colors.primary};
		font-size: 1.6rem;
		text-decoration: underline;
		margin-left: ${({ smallMargin }) => (smallMargin ? `1rem` : `4rem`)};
	}
	svg {
		height: 2.5rem;
		margin-right: 1rem;
	}
`;

export const VerifyBanner = styled.div`
	/* box-shadow: 0px 11px 24px #ececec; */
	background-color: ${theme.colors.grayLight};
	display: flex;
	justify-content: space-between;
	padding: 1rem 0;
	p {
		padding-left: 2rem;
		margin: auto 0;

		${media.mobileOnly`
			display: none;
		`};
	}
	div {
		margin-left: auto;
		button {
			margin-left: 1rem;
		}
		button:last-child {
			margin-right: 1rem;
		}
	}
	a {
		color: #fff;
		text-decoration: underline;
	}
`;

export const SkipLink2 = styled(A)`
	margin-bottom: -4rem;
	color: ${theme.colors.secondary};
	float: right;
	margin-top: 3rem;
	font-size: 1.6rem;
	&&:hover {
		color: ${theme.colors.secondaryDark};
	}

	${({ logout }) =>
		logout &&
		`
		color: ${theme.colors.primary};
		&&:hover { color: ${theme.colors.primaryDark}; }
	`}
`;
